import { merge } from 'lodash'
import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  pageLoaded: boolean
  isPreloaderPlayed: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state: Partial<State>) => void
}

const initialState: State = {
  pageLoaded: false,
  isPreloaderPlayed: false
}

const useLoaderStore = create(
  devtools(
    subscribeWithSelector(
      immer<State & Actions>((set) => ({
        ...initialState,
        setState: (state) => set((prevState) => merge(prevState, state))
      }))
    ),
    { name: 'LoaderStore' }
  )
)

export { useLoaderStore }
